// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__25J2q","empty":"ModalGraph_empty__1A1VN"};